import q from "../styles/components/examQuestion.module.scss";
import { getQuestionTextDirection, hasMeaningfulBody, isHtmlContent } from "../assets/utils/utils";
import { resolveHtmlEmbeddedMediaUrls } from "../assets/utils/mediaUrl";
import { getQuestionImages, getQuestionVoices } from "../assets/utils/questionMedia";
import QuestionImageGallery from "./QuestionImageGallery";
import QuestionAudioList from "./QuestionAudioList";

const normalizeMultilineText = (value) => {
    if (value == null) return "";
    return String(value).replace(/\\n/g, "\n");
};

const QuestionContent = ({ body, imageURL, audioURL, images, voices, question, id }) => {
    const textDirection = getQuestionTextDirection(body);
    const textAlignStyle = {
        direction: textDirection,
        textAlign: textDirection === "ltr" ? "left" : "right",
    };
    const showBody = hasMeaningfulBody(body);
    const bodyIsHtml = isHtmlContent(body);
    const resolvedBodyHtml = bodyIsHtml ? resolveHtmlEmbeddedMediaUrls(body) : body;

    const mediaSource = question || { image: imageURL, voice: audioURL, images, voices };
    const imageItems = getQuestionImages(images?.length ? { images, image: imageURL } : mediaSource);
    const voiceItems = getQuestionVoices(voices?.length ? { voices, voice: audioURL } : mediaSource);

    if (!showBody && !imageItems.length && !voiceItems.length) return null;

    return (
        <div className={q.content} style={textAlignStyle}>
            {showBody && (
                bodyIsHtml ? (
                    <div
                        className={`${q.bodyText} ${q.bodyHtml}`}
                        style={textAlignStyle}
                        dangerouslySetInnerHTML={{ __html: resolvedBodyHtml }}
                    />
                ) : (
                    <p className={q.bodyText} style={textAlignStyle}>
                        {normalizeMultilineText(body)}
                    </p>
                )
            )}
            <QuestionImageGallery images={imageItems} />
            <QuestionAudioList voices={voiceItems} idPrefix={id != null ? String(id) : "question"} />
        </div>
    );
};

export default QuestionContent;
